import React, { useEffect, useState } from "react";
import Sidebar from "../../Common/Sidebar";
import EmployerLayout from "./Common/EmployerLayout";
import PackageCard from "./PackageCard";
import NoSubscriptionAlert from "./NoSubscriptionAlert";
import EmployerSubscriptions from "./EmployerSubscriptions";
import { GetUserSubscriptions } from "../../../Redux/Slices/Package";
import "../../../asset/new/css/employer-modern.css";

const MyPackage = () => {
  useEffect(() => {
    document.title = "My Package | CAJobPortal";
    salesHistoryHandler();
  }, []);

  const [salesHistory, setSalesHistory] = useState(null);

  const salesHistoryHandler = async () => {
    let data = await GetUserSubscriptions();
    setSalesHistory(data?.subscriptions);
  };

  return (
    <div className="employer-layout">
      <Sidebar />
      <EmployerLayout breadcrumbs={['Employer', 'My Package']}>
        <div className="employer-page-header">
          <h1 className="employer-page-title">My Package</h1>
        </div>

        {/* Alert */}
        <NoSubscriptionAlert salesHistory={salesHistory} />

        {/* Subscription */}
        {salesHistory && <EmployerSubscriptions salesHistory={salesHistory} />}

        {/* Package Plans */}
        <div className="employer-mb-4">
          <PackageCard />
        </div>
      </EmployerLayout>
    </div>
  );
};

export default MyPackage;
